import { Stack, styled } from "@mui/material";

export const PrintStatementWrapper = styled(Stack)(({ theme }) => {
	return {
		gap: "var(--flex-gap)",
		overflow: "hidden",
		"& .filter-bar": {
			padding: "var(--basic-padding)",
			backgroundColor: "var(--light-color)",
			borderRadius: "16px",
			display: "flex",
			gap: "var(--flex-gap)",
			justifyContent: "space-between",
			alignItems: "flex-start",
			[theme.breakpoints.down("laptop")]: {
				flexDirection: "column",
				alignItems: "stretch",
			},
		},
		"& fieldset": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "space-between",
			overflow: "hidden",
			flex: 1,
		},
		"& .print-statement-table-box": {
			borderRadius: "8px",
			backgroundColor: "var(--light-color)",
			"& .table-title": {
				flexDirection: "row",
				gap: "var(--flex-gap)",
				alignItems: "center",
				justifyContent: "space-between",
				backgroundColor: "var(--primary-color)",
				padding: "calc(var(--basic-padding)/2)",
				borderRadius: "inherit",
			},
			"& .MuiTableContainer-root": {
				borderTopLeftRadius: "0px",
				borderTopRightRadius: "0px",
				borderBottomLeftRadius: "inherit",
				borderBottomRightRadius: "inherit",
				"& .MuiTableHead-root": {
					"& .MuiTableCell-root": {
						whiteSpace: "normal",
					},
				},
			},
		},
		"& .MuiCard-root": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "space-between",
		},
		"& .card-content": {
			padding: "0",
			display: "flex",
			flexDirection: "column",
			height: "100%",
		},
		"& .card-content:last-child": {
			paddingBottom: 0,
		},
		"& .request-statement-form": {
			display: "flex",
			flexDirection: "column",
			gap: "var(--flex-gap)",
			overflow: "hidden",
			"& .form-action-stack": {
				gap: "calc(var(--flex-gap)/2)",
				[theme.breakpoints.up("miniTablet")]: {
					flexDirection: "row",
				},
			},
		},
	};
});
